<template>
    <div class="modal fade" id="address_selector_modal" tabindex="-1" role="dialog" aria-labelledby="address_selector_modal_label" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title"> {{ $helper.trans('Address_selector') }} </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <select class="input-big w-100 select-style-ups" id="address_selector_modal_select" v-model="selectedAddressId">
                        <option value="">{{ $helper.trans('Select_address') }}</option>
                        <option v-for="(value, index) in addressValues"
                            :key="index"
                            :value="index"
                        >
                            {{ value }}
                        </option>
                    </select>
                </div>
                <div class="modal-footer-custom pb-2 pt-0">
                    <div class="input-grid">
                        <button type="button" @click="saveModal();" class="btn btn-primary">{{ $helper.trans('Submit') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import store from "../../../store";
export default {
    store,
    data: function(){
        return {
            selectedAddressId: '',
        };
    },
    created: function(){
        let vueThis = this;
        $(function(){
            vueThis.createSelect2();

            $('#address_selector_modal_select').on('change', function(){
                vueThis.selectedAddressId = $(this).val();
            });
        });
        
    },
    updated: function(){
        let vueThis = this;
        this.$nextTick(function(){
            vueThis.createSelect2();
        });
    },
    methods:{
        createSelect2: function(){
            $('#address_selector_modal_select').select2({
                width: '100%',
                dropdownCssClass: 'select2_customization',
                dropdownParent: $('#address_selector_modal').find('.modal-body').eq(0)
            });
        },
        saveModal: function(){      
            this.$helper.fillAddress(this.$store.state.addressSelectorType, this.selectedAddressId, this.isImport, this.$store.state.defaultAddressSelector);
            $('#address_selector_modal').modal('hide');
            this.selectedAddressId = '';
            $('#address_selector_modal_select').val(null).trigger('change.select2');
            this.$store.state.awaitingActions.reselectCountries.from = true;
            this.$store.state.awaitingActions.reselectCountries.to = true;
            this.$store.state.awaitingActions.forceUpdate.initialCalculatorForm = true;
            this.$store.state.defaultAddressSelector = true;
        }
    },
    computed: {
        addressValues(){
            let vueThis = this;
            let values = {};

            $.each(vueThis.$store.state.userAddresses[vueThis.$store.state.addressSelectorType], function(index, element){
                values[element.id] = `${element.username_or_company} | ${vueThis.$helper.getCountryCode(element.country)} | ${element.zip_code}`;
            });

            return values;
        },
        isImport(){
            return this.$store.state.to.country === 'lt';
        },
    },
}
</script>
